/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ComuneEsercenteSummaryDTO { 
    id?: string;
    slug?: string;
    nome?: string;
    url_logo_comune?: string;
    url_comune?: string;
    conteggio_bandi_esercente?: number;
}

